/**
 * Brand-dependent URLs and addresses (ZON-279).
 *
 * Defaults are today's zonedlabs.com values, so nothing changes until the env
 * vars are set. The golfrecruit.ai cutover sets them instead of changing code:
 *
 *   VITE_SITE_URL               marketing site   https://zonedlabs.com
 *   VITE_COMPANY_EMAIL_DOMAIN   team mailboxes   zonedlabs.com
 */

const trimSlash = (value: string) => value.replace(/\/+$/, "");

export const SITE_URL = trimSlash(import.meta.env.VITE_SITE_URL || "https://zonedlabs.com");

export const COMPANY_EMAIL_DOMAIN = import.meta.env.VITE_COMPANY_EMAIL_DOMAIN || "zonedlabs.com";

/** A team mailbox, e.g. companyEmail("feedback"). */
export const companyEmail = (localPart: string) => `${localPart}@${COMPANY_EMAIL_DOMAIN}`;

/**
 * Base for parsing relative in-app paths with `new URL()`. Only the path and
 * query are read, so the host is a placeholder and never reaches the user.
 */
export const URL_PARSE_BASE = "https://app.invalid";
